import Main from '@/module/base/view/main';
import parentView from '@/module/base/view/parent-view';

const _import = path => {
    return () => import(`@/module/base/view/${path}.vue`);
};
export default [
    {path: '/login', name: 'login', meta: {title: '登录', noAuth: true}, component: _import('login')},
    {path: '/', name: 'base', redirect: '/home', meta: {noAuth: true,breadShow:false}, component: Main,
        children: [
            {path: 'home', name: 'home', meta: {icon: 'md-home', title: '首页'}, component: _import('Home')}
            /*{path: '/public', name: 'public', meta: {title: '公共'}, component: parentView,
                children: [
                    {path: 'home', name: 'home', meta: {icon: 'md-home', title: '首页'}, component: _import('Home')},
                ]
            }*/
        ]
    },
    {path: '*', name: 'error_404', meta: {noAuth: true}, component: _import('404')}
];
